import { Draggable } from "@fullcalendar/interaction";
import { createRef } from "react";
import { useEffect, useRef, useState, useContext } from "react";
import api from "../../services/api";
import { AccountContext } from "../../context/account";
import './ExternalEvents.css'

function ExternalEvents() {
  const containerRef = createRef();
  const dragEnabled = useRef(false);
  const [filterText, setFilterText] = useState('');

  const [accountInfo, setAccountInfo] = useContext(AccountContext);

  const [eventTypes, setEventTypes] = useState([]);

  function loadEventTytpes() 
  { 
    api
        .get(`/calendar/eventTypes`, {
          headers: {
            'Authorization': `Basic ${accountInfo.token}`
          }
        })
        .then((response) => { 
          setEventTypes(response.data)
        })
        .catch((err) => {
          console.log("ERRO: " + err)
        })     
  }

  useEffect(() => {
    if(dragEnabled.current) return;
    dragEnabled.current = true; // avoid running twid due strict mode
    loadEventTytpes();
    new Draggable(containerRef.current, {
      itemSelector: '.fc-event-drag',
      eventData: function(eventEl) {
        return {
          title: eventEl.innerText
        };
      }
    });
  }, []);

  // 1. Filtra os eventos pelo nome (case insensitive, match parcial)
  const filteredEvents = eventTypes.filter(event =>
    event.name.toLowerCase().includes(filterText.toLowerCase())
  );

  // 2. Agrupa os eventos filtrados
  const groupedEvents = filteredEvents.reduce((groups, event) => {
    const groupId = event.group_id || 0;
    if (!groups[groupId]) groups[groupId] = [];
    groups[groupId].push(event);
    return groups;
  }, {});

  return (
    <div ref={containerRef} className="ExternalEvents">       
        <strong>Available Events</strong>
        <input
          type="text"
          placeholder="Filter"
          value={filterText}
          onChange={e => setFilterText(e.target.value)}
          style={{ marginTop: '1rem', padding: '0.4rem', width: '80%' }}
        />
        {Object.entries(groupedEvents).map(([groupId, events]) => (
          <div key={groupId} style={{ marginBottom: '0px' }}>
            <b>{groupId === "0" ? "No Group" : `Group ${groupId}`}</b>
            
            {events.map(event => {
              let toolTip = `Weight: ${event.weight}\nGroup ID: ${event.group_id}\nDescription: ${event.description}`;
    
              const baseClass = parseInt(event.schedule_enabled) !== 0 ? 'fc-event-drag' : 'fc-event-disabled';
    
              return (
                <div
                  key={event.code}
                  event-code={event.code}
                  title={toolTip}
                  className={`${baseClass} fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event`}
                >
                  <div className='fc-event-main'>{event.name}</div>
                </div>
              );
            })}
          </div>
        ))}
    </div>
  );

  /*return (
    <div ref={containerRef} className="ExternalEvents">
        <p/>
        <strong>Available Events</strong>

        {eventTypes.map(event => {
          let toolTip = `Weight: ${event.weight}\nGroup ID: ${event.group_id}\nDescription: ${event.description}`
          if(parseInt(event.schedule_enabled) !== 0) {            
            return  <div key={event.code} event-code={event.code} title={toolTip} className='fc-event-drag fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event'>
                      <div className='fc-event-main'>{event.name}</div>
                    </div>
          } else {
            return  <div key={event.code} event-code={event.code} title={toolTip} className='fc-event-disabled fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event'>
                      <div className='fc-event-main'>{event.name}</div>
                    </div>
          }
        })}        
        <p/>
    </div>
  )*/
}

export default ExternalEvents;